import PropTypes from "prop-types";
import React from "react";
import Tr from 'translations/Translations';
import {AuctionType} from "constants/AuctionType";
import Typography from "components/Typography";
import BoldTypography from "components/BoldTypography";
import Link from "@material-ui/core/Link";
import {AuctionStatusLabel} from "constants/AuctionStatus";

function AuctionTypeList(
    {
        auctionType,
        auctions
    }) {

    return (<>
            <BoldTypography>{Tr(auctionType === AuctionType.PROD ? 'auctions_prod' : 'auctions_test')}</BoldTypography>
            <Typography>{Tr('auction_numbers')}:
                {auctions.length === 0 ?
                    <BoldTypography component='span'>{Tr('auctions_empty')}</BoldTypography>
                    :
                    auctions.map((x, i) => (<Typography key={x.auctionId} component='span'>
                            <Link href={x.url}>
                                {x.auctionId + " (" + AuctionStatusLabel(x.status) + ")"}
                            </Link>
                            {(i < auctions.length - 1 && auctions.length > 1) && '; '}
                        </Typography>
                    ))
                }
            </Typography>
        </>
    )
}

AuctionTypeList.propTypes = {
    auctions: PropTypes.array.isRequired,
    auctionType: PropTypes.string.isRequired,
}

export default AuctionTypeList;
